export const createCookie = (
  name: string,
  value: string,
  days?: number
): string | boolean => {
  if (!name || !value) return false;

  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires= ${date.toUTCString()}`;
  }
  const cookie = `${name}=${value}${expires}; path=/`;
  document.cookie = cookie;
  return cookie;
};

export const getCookieValue = (
  cookieList: string,
  name: string
): string | boolean => {
  if (!name || !cookieList) return false;

  const cookieName = cookieList.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (cookieName) return cookieName[2];

  return false;
};
